import List from '../../containers/Logs/List';
import Edit from '../../containers/Logs/Edit';
import Create from '../../containers/Logs/Create';
import Show from '../../containers/Logs/Show';

export default { List, Edit, Create, Show };
